import React from 'react';
import {
  MemberRowMenu,
  type MemberRowMenuProps,
} from '../../shared/MemberRowMenu/MemberRowMenu';
import type { GroupLeaderboardEntry } from '../../../src/friends/helpers/groupLeaderboard.helper';
import type { FriendStatus } from './GroupLeaderboardList';
import { GROUP_ROW_MENU_REASONS } from '../../../src/friends/constants/friendInvite.constants';

export interface LeaderboardRowMenuProps {
  entry: GroupLeaderboardEntry;
  position: { top: number; right: number };
  friendStatus: FriendStatus | null;
  /** True while a friend request to this row's user is in flight (after confirm). */
  isFriendRequestSending?: boolean;
  /** True while removing a member from the group (any row). */
  isRemoveMemberSending?: boolean;
  canRemove: boolean;
  theme: MemberRowMenuProps['theme'];
  onClose: () => void;
  onAddFriend: (entry: GroupLeaderboardEntry) => void;
  onRemoveMember: (entry: GroupLeaderboardEntry) => void;
}

export const LeaderboardRowMenu: React.FC<LeaderboardRowMenuProps> = ({
  canRemove,
  isRemoveMemberSending = false,
  isFriendRequestSending = false,
  ...rest
}) => (
  <MemberRowMenu
    {...rest}
    isFriendRequestSending={isFriendRequestSending}
    canRemove={canRemove && !isRemoveMemberSending}
    removeLabel="Remove from group"
    removeDisabledReason={
      isRemoveMemberSending
        ? GROUP_ROW_MENU_REASONS.MEMBER_REMOVAL_SENDING
        : 'Only group creator can remove'
    }
  />
);
